import { useEffect, useState, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import axiosInstance from "../../../api/Axios";
import {
  setNotificationCount,
  setNotifications,
} from "../../../store/slices/notificationSlice";

const useNonDispatchNotifications = ({
  state,
  id,
  pageSize,
  currentPage,
  readStatus,
}) => {
  function getCookie(name) {
    const cookies = document.cookie.split("; ");
    for (let i = 0; i < cookies.length; i++) {
      const [cookieName, cookieValue] = cookies[i].split("=");
      if (cookieName === name) {
        return cookieValue;
      }
    }
    return null;
  }
  const csrfToken = getCookie("csrftoken");
  const [notifications2, setNotifications2] = useState([]);
  const [notificationCount2, setNotificationCount2] = useState(0);
  const [notificationsLoader2, setNotificationsLoader2] = useState(false);
  console.log(notificationCount2);
  const notificationCount = useSelector(
    (state) => state.notificationList.listCount
  );

  const dispatch = useDispatch();

  const fetchNotifications = useCallback(
    async (text = "WithLoader") => {
      setNotificationsLoader2(text === "WithLoader" ? true : false);

      const url = state
        ? `/notificationevent/?page=${currentPage}&page_size=${pageSize}`
        : `/notificationevent/?read=${false}`;
      try {
        const listResponse = await axiosInstance.get(url);
        const notificationList = listResponse?.data?.results ?? [];
        setNotifications2(notificationList);
        setNotificationCount2(listResponse?.data?.count || 0);
      } catch (error) {
        console.error("Failed to fetch notifications:", error);
      } finally {
        setNotificationsLoader2(false);
      }
    },
    [currentPage, pageSize, state]
  );

  useEffect(() => {
    fetchNotifications();
  }, [fetchNotifications]);

  useEffect(() => {
    const markAsRead = async (passId) => {
      try {
        await axiosInstance.post(`/notificationevent/${passId}/`, "", {
          headers: {
            "X-CSRFToken": csrfToken,
          },
        });
        fetchNotifications("withoutLoader");
        fetchNotificationsDispatch();
      } catch (error) {
        fetchNotifications("withoutLoader");
        fetchNotificationsDispatch();
        console.error("Failed to fetch notifications:", error);
      }
    };
    const markAsRead2 = async (passId) => {
      try {
        const listResponse = await axiosInstance.get(
          `/notificationevent/?read=${false}`
        );
        const notificationList = listResponse?.data?.results ?? [];
        setNotifications2(notificationList);
        setNotificationCount2(listResponse?.data?.count || 0);
        await axiosInstance.post(`/notificationevent/${passId}/`, "", {
          headers: {
            "X-CSRFToken": csrfToken,
          },
        });
        fetchNotificationsDispatch();
      } catch (error) {
        fetchNotificationsDispatch();
        console.error("Failed to fetch notifications:", error);
      }
    };
    const fetchNotificationsDispatch = async () => {
      try {
        const countResponse = await axiosInstance.get(
          "/notificationevent/?flag=count"
        );
        const newCount = countResponse?.data?.data?.count ?? 0;
        if (newCount !== notificationCount) {
          dispatch(setNotificationCount(newCount));

          const listResponse = await axiosInstance.get(
            `/notificationevent/?read=false`
          );
          const notificationList = listResponse?.data?.results ?? [];

          if (notificationList.length > 0) {
            dispatch(setNotifications(notificationList));
          } else {
            dispatch(setNotifications([]));
          }
        }
      } catch (error) {
        console.log("Failed to fetch notifications:", error);
      }
    };
    if (id && !readStatus) {
      if (state) {
        markAsRead(id);
      } else {
        markAsRead2(id);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [readStatus, id, state]);

  return {
    notifications: notifications2,
    notificationCount: notificationCount2,
    notificationsLoader: notificationsLoader2,
  };
};

export default useNonDispatchNotifications;
